window.addEventListener('keyup', event => {
    if(event.key === 'Escape') {
        const customEvt = new CustomEvent('esc')
        dispatchEvent(customEvt)
    }
})